const userConsentsScreenShow = (consentsConfig = [], userConsentsData = {}) => {
    if (consentsConfig.length === 0) {
        return false;
    }
    const mandatoryConsents = consentsConfig.filter(consent => consent.isMandatory);

    for (const consentObj of mandatoryConsents) {
        for (const consentKey of consentObj.channelKeys) {
            // return true if user has not provided a mandatory consent
            if (!(userConsentsData[consentKey.toLowerCase()]?.value)) {
                return true;
            }
        }
    }
    return false;
};

export {
    userConsentsScreenShow
};
